import { API_BASE } from "config/api";
import { withAuthHeaders } from "services/authHeader";
import { apiFetch } from "services/apiFetch";

/**
 * Fetch all students across all countries and states
 */
export async function getAllStudents() {
  try {
    const url = new URL("api/students/getAllStudents", API_BASE);

    const res = await apiFetch(url, {
      method: "GET",
      headers: withAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    });

    const result = await res.json();

    if (result.status === "success" && Array.isArray(result.data)) {
      return result.data;
    } else {
      throw new Error(result.message || "Failed to fetch students");
    }
  } catch (error) {
    console.error("Error in getAllStudents:", error);
    throw error;
  }
}

export async function assignAnnotatorToStudent(
  student_id,
  slot,
  annotator_id,
  current_user_id = null
) {
  const url = new URL("api/students/assignAnnotator", API_BASE);
  const res = await apiFetch(url.toString(), {
    method: "POST",
    headers: withAuthHeaders({
      "Content-Type": "application/json",
      Accept: "application/json",
    }),
    body: JSON.stringify({ student_id, slot, annotator_id, current_user_id }),
  });
  const json = await res.json();
  if (json?.status !== "success") {
    throw new Error(json?.message || "Assign API failed");
  }
  return json;
}
